export const SmartSessionMode = {
    USE: '0x00',
    ENABLE: '0x01',
    UNSAFE_ENABLE: '0x02',
};
//# sourceMappingURL=types.js.map